module.exports = __webpack_public_path__ + "static/media/support.ea8acb96.svg";